// Uppy is not an npm dependency - it's a vendored script (public/vend/uppy.min.js) that most
// creator-dashboard pages load via a plain <script> tag pointed at `public_asset_path`. That
// leaves any page which doesn't declare that tag (e.g. the episode-upload wizard opened in a
// modal from Live Events scheduling) with no `window.Uppy` at all. This loads it on demand
// instead, mirroring the `loadTus()` pattern in packs/episode_upload_worker.js.

let uppyPromise = null;

function uppySrc() {
  const el = document.querySelector("[data-uppy-src]");
  return el ? el.dataset.uppySrc : "/vend/uppy.min.js";
}

export function loadUppy() {
  if (window.Uppy) return Promise.resolve(window.Uppy);

  if (!uppyPromise) {
    uppyPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = uppySrc();
      script.onload = () => resolve(window.Uppy);
      script.onerror = (error) => reject(error);
      document.head.appendChild(script);
    }).catch((error) => {
      // Clear the memo on failure so a later attempt (e.g. the creator retrying the drop) can
      // retry the fetch instead of being stuck on a permanently-rejected promise.
      uppyPromise = null;
      throw error;
    });
  }

  return uppyPromise;
}
